<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Payment Report</h1>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-2"><input class="form-control" [(ngModel)]="search" type="text"
                            placeholder="Search" /></div>
                    <div class="col-sm-2">
                        <mat-select placeholder="Circle" [(ngModel)]="circle" (click)="setSearchValue('circle')"
                            multiple>
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option value="{{cir.id}}" *ngFor="let cir of circles">{{cir.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2">
                        <mat-select placeholder="Payment Mode" [(ngModel)]="payment_mode">
                            <mat-option>All</mat-option>
                            <mat-option value="1">Cash</mat-option>
                            <mat-option value="2">Cheque</mat-option>
                            <mat-option value="3">Razor Pay</mat-option>
                            <mat-option value="4">EMI</mat-option>
                            <mat-option value="5">Net Banking</mat-option>
                            <mat-option value="6">Insurance</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Payment Date</mat-label>
                            <mat-date-range-input [rangePicker]="picker">
                                <input matStartDate #dateRangeStart placeholder="Start date">
                                <input matEndDate #dateRangeEnd placeholder="End date"
                                    (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearDate()">clear</mat-icon>
                    </div>

                    <div class="col-sm-2">
                        <mat-form-field appearance="fill">
                            <mat-label>Payment Received Date</mat-label>
                            <mat-date-range-input [rangePicker]="picker1">
                                <input matStartDate #paymentReceivedStart placeholder="Start date">
                                <input matEndDate #paymentReceivedEnd placeholder="End date"
                                    (dateChange)="dateRangeChangefollowUp(paymentReceivedStart, paymentReceivedEnd)">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker1></mat-date-range-picker>
                        </mat-form-field>
                        <mat-icon (click)="clearPaymentReceivedDate()">clear</mat-icon>
                    </div>

                    <div class="col-sm-2">
                        <mat-select placeholder="Verified By (Accounts)" [(ngModel)]="bd" (click)="setSearchValue('bds')" multiple
                            #itemSelect="ngModel">
                            <input class="mySearchInput" #bd_search focused="'true'" type="text"
                                (keyup)="searchOnSelect($event.target.value, 'bds')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="bd_search">
                            <mat-option value="{{bd.id}}" *ngFor="let bd of bds">{{bd.name}}</mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <button type="button" class="btn btn-primary ml-2 mb-4"
                            (click)="loadPaymentReportData(0,perpage)"> <i class="fa fa-search" aria-hidden="true"></i>
                            Search Data</button>
                        <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                                class="fa fa-sync"></i> Reset Filters</button>
                    </div>

                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3">
                    <button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadPaymentReportData(0,perpage)"><i class="fa fa-sync"
                            [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                    <button *ngIf="myrole=='1'" type="button" class="btn btn-success ml-2" [disabled]="loading"
                        (click)="exportProductList()"><i class="fa fa-file-excel"></i> Export List</button>

                </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Patient ID</th>
                            <th>Patient Name</th>
                            <th>Patient Contact No</th>
                            <th>Circle</th>
                            <th>Scan Date</th>
                            <th>Payment Date</th>
                            <th>Total Payment</th>
                            <th>Down Payment Received</th>
                            <th>Balance Payment</th>
                            <th>Payment Mode</th>
                            <th>Convert Type</th>
                            <th>Converted By</th>
                            <th>Any Other Dental Procedure</th>
                            <th>Payment Screenshot</th>
                            <th>Transaction ID</th>
                            <th>Verified by Accounts</th>
                            <th>Verification Date</th>
                            <th>Accounts Remarks</th>
                            <th>Payment Receive Date</th>
                            <th>Payment received amount (By Accounts)</th>
                            <th>Verified by</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let payment of paymentData;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{payment.glamyo_patient_id}}</td>
                            <td>{{payment.lead_name}}</td>
                            <td>{{payment.mobile}}</td>
                            <td>{{payment.circle_name}}</td>
                            <td>
                                <span *ngIf="payment.scan_done_date">{{payment.scan_done_date*1000|date:'dMMM, yyyy'}}</span>
                                <span *ngIf="!payment.scan_done_date">-</span>
                            </td>
                            <td>
                                <span *ngIf="payment.payment_datetime">{{payment.payment_datetime*1000|date:'dMMM, yyy'}}</span>
                                <span *ngIf="!payment.payment_datetime">-</span>
                            </td>
                            <td>{{payment.billed_amt}}</td>
                            <td>{{payment.received_amt}}</td>
                            <td>{{payment.balanceAmount}}</td>
                            <td>{{payment.payment_mode}}</td>
                            <td>{{payment.convert_type}}</td>
                            <td>{{payment.converted_transaction_by}}</td>
                            <td>{{payment.any_other_dental}}</td>
                            <td>
                                <div *ngIf="payment.payment_screenshot_link; else noCopy">
                                    <span><a href="{{payment.payment_screenshot_link}}"
                                            target="_blank">View</a><br></span>
                                </div>
                                <ng-template #noCopy>Not uploaded</ng-template>
                            </td>
                            <td>{{payment.transaction_id}}</td>
                            <td>{{payment.verified_by_accounts}}</td>
                            <td>
                                <span *ngIf="payment.verification_date_by_accounts">{{payment.verification_date_by_accounts*1000|date:'dMMM, yyyy'}}</span>
                                <span *ngIf="!payment.verification_date_by_accounts">-</span>
                            </td>
                            <td>{{payment.accounts_remarks}}</td>
                            <td>
                                <span *ngIf="payment.payment_rec_date_by_acc">{{payment.payment_rec_date_by_acc*1000|date:'dMMM, yyyy'}}</span>
                                <span *ngIf="!payment.payment_rec_date_by_acc">-</span>
                            </td>
                            <td>{{payment.rec_amount_by_account}}</td>
                            <td>{{payment.accounts_user_id_name}}</td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="20" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !paymentData.length">
                            <td colspan="20"><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>